import React from "react"; 
const POSTER = '/videos/trapound-poster-1280x720.png';

export default function WelcomeVideoModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-md">
      <div className="bg-white dark:bg-gray-800 rounded-3xl p-8 shadow-2xl max-w-4xl w-full mx-4 border border-blue-400/30">
        <div className="text-center mb-6">
          <h2 className="text-3xl font-extrabold text-gray-900 dark:text-white">
            Welcome to Trapound!
          </h2>
          <p className="text-gray-500 dark:text-gray-400 mt-2">
            Watch this product overview to learn how to set up your first trading journal.
          </p>
        </div>
        
        {/* Video Container */}
        <div className="relative aspect-video w-full mb-8 rounded-2xl overflow-hidden bg-black shadow-inner">
          <video 
            className="w-full h-full object-contain"
            controls
            poster={POSTER}      
            playsInline  // Required for iOS
            preload="auto"
          >
            {/* DIRECT LINK TO PUBLIC FOLDER */}
            <source src="/videos/welcome.mp4?v=20260712" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <button
          onClick={onClose}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 rounded-2xl shadow-lg shadow-blue-500/30 transition transform active:scale-95"
        >
          I'm ready to get started!
        </button>
      </div>
    </div>
  );
}
